// extracted by mini-css-extract-plugin
export var currencyInput = "_ol-1";
export var currencySymbol = "_ol-0";